import {get, loggedGet, post} from '@/library/ajax'
const apiUrl = process.env.VUE_APP_API_URL
const mjmlUrl = process.env.VUE_APP_MJML_URL

export const getCountry = () => {
  return get(apiUrl + '/country', {})
}

export const getCity = () => {
  return get(apiUrl + '/city?country=Indonesia', {})
}
export const stillLogged = () => {
  return loggedGet(apiUrl + '/user/ping', {})
}
export const mjHtml = (mjml) => {
  return post(mjmlUrl + '/mjml', { mjml: [mjml]})
}